import { ROUTES } from '../routes/routes'

const CHECK_PHONE_REGEX = /^\+?[\d\(\)\s-]+$/

/**
 * Возвращает cookie по названию
 * @param name
 */
export function getCookie(name: string): string | undefined {
  let matches

  if (typeof document !== 'undefined') {
    matches = document.cookie.match(
      new RegExp(`(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`),
    )
  }

  return matches ? decodeURIComponent(matches[1]) : undefined
}

export function getLogonUrl(): string {
  return `${ROUTES.LOGON_PAGE}`
}

export function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function getDigits(value: string): string {
  return value.replace(/[^\d]/gi, '')
}

export function getPhoneNumber(value: string): string {
  const phoneNumber = `${getDigits(value)}`

  return phoneNumber
}

export function getExtractedLogin(login: string): string {
  const trimmedLogin = login.trim()

  return CHECK_PHONE_REGEX.test(trimmedLogin) ? getPhoneNumber(trimmedLogin) : trimmedLogin
}

export function checkIsPhone(login: string): boolean {
  const trimmedLogin = login.trim()

  return CHECK_PHONE_REGEX.test(trimmedLogin)
}

export function isServerErrorCode(code: number) {
  return code >= 500 && code < 600
}

export function capitalizeFirstLetter(str: string) {
  if (!str) return str

  return str.charAt(0).toUpperCase() + str.slice(1)
}
